import { useNavigate } from 'react-router-dom';

export default function PrivacyPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background-50">
      <header className="bg-white border-b border-background-200 sticky top-0 z-40">
        <div className="max-w-3xl mx-auto px-4 md:px-6 h-16 flex items-center justify-between">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-foreground-600 hover:text-foreground-900 text-sm transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i>
            뒤로 가기
          </button>
          <h1 className="text-sm font-semibold text-foreground-950">개인정보처리방침</h1>
          <div className="w-20" />
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 md:px-6 py-8">
        <div className="bg-white rounded-xl border border-background-200 p-6 md:p-8">
          <h1 className="font-heading text-2xl font-bold text-foreground-950 mb-2">개인정보처리방침</h1>
          <p className="text-xs text-foreground-500 mb-8">시행일: 2026년 1월 1일</p>

          <div className="space-y-8 text-sm text-foreground-700 leading-relaxed">
            <section>
              <h2 className="text-base font-bold text-foreground-950 mb-2">제1조 (수집하는 개인정보의 항목)</h2>
              <p>회사는 서비스 제공을 위해 다음과 같은 개인정보를 수집합니다.</p>
              <ul className="space-y-1.5 list-disc pl-5 mt-2">
                <li>필수항목: 이름, 이메일 주소, 휴대폰 번호, 비밀번호</li>
                <li>학원장 회원: 학원명, 지역(시/도, 구/군), 학원 주소</li>
                <li>학생 회원: 학년, 학교명, 생년월일</li>
                <li>서비스 이용 과정에서 생성되는 검사 결과 및 이용 기록</li>
              </ul>
            </section>

            <section>
              <h2 className="text-base font-bold text-foreground-950 mb-2">제2조 (개인정보의 수집 및 이용 목적)</h2>
              <ul className="space-y-1.5 list-disc pl-5">
                <li>회원 가입 및 본인 확인, 서비스 제공</li>
                <li>이용권 결제 확인 및 승인 처리</li>
                <li>검사 결과의 저장·조회·인쇄 기능 제공</li>
                <li>문의 및 건의사항 응대</li>
                <li>서비스 개선 및 신규 기능 안내</li>
              </ul>
            </section>

            <section>
              <h2 className="text-base font-bold text-foreground-950 mb-2">제3조 (개인정보의 보유 및 이용기간)</h2>
              <p>
                회사는 회원 탈퇴 시 또는 수집 목적 달성 시 지체 없이 해당 개인정보를 파기합니다. 다만, 관련 법령에 따라 보존할 필요가 있는 경우에는 해당 기간 동안 보관합니다.
              </p>
            </section>

            <section>
              <h2 className="text-base font-bold text-foreground-950 mb-2">제4조 (개인정보의 제3자 제공)</h2>
              <p>
                회사는 회원의 개인정보를 원칙적으로 외부에 제공하지 않습니다. 다만, 법령에 의하거나 회원의 별도 동의가 있는 경우에 한하여 제공할 수 있습니다.
              </p>
            </section>

            <section>
              <h2 className="text-base font-bold text-foreground-950 mb-2">제5조 (개인정보의 처리 위탁)</h2>
              <p>
                회사는 원활한 서비스 제공을 위해 개인정보 처리 업무를 외부에 위탁하지 않습니다. 서비스는 안전한 클라우드 인프라(Supabase)를 통해 운영되며, 회사는 데이터 보안에 만전을 기합니다.
              </p>
            </section>

            <section>
              <h2 className="text-base font-bold text-foreground-950 mb-2">제6조 (회원의 권리와 행사 방법)</h2>
              <p>
                회원은 언제든지 자신의 개인정보를 조회하거나 수정할 수 있으며, 가입 해지(회원 탈퇴)를 요청할 수 있습니다. 관련 요청은 서비스 내 문의 기능을 통해 접수할 수 있습니다.
              </p>
            </section>

            <section>
              <h2 className="text-base font-bold text-foreground-950 mb-2">제7조 (개인정보의 파기)</h2>
              <p>
                개인정보는 보유기간 경과 또는 처리 목적 달성 후 지체 없이 파기합니다. 전자적 파일 형태의 정보는 복구할 수 없는 기술적 방법으로 삭제합니다.
              </p>
            </section>

            <section>
              <h2 className="text-base font-bold text-foreground-950 mb-2">제8조 (개인정보 보호책임자)</h2>
              <p>
                회사는 개인정보 처리에 관한 업무를 총괄하는 개인정보 보호책임자를 지정하고 있습니다. 개인정보 관련 문의는 서비스 내 "문의 및 건의사항"을 통해 접수해 주시기 바랍니다.
              </p>
            </section>

            <section>
              <h2 className="text-base font-bold text-foreground-950 mb-2">제9조 (개인정보처리방침의 변경)</h2>
              <p>
                본 개인정보처리방침은 관련 법령 및 서비스 정책의 변경에 따라 개정될 수 있으며, 개정 시 적용일자와 변경 내용을 서비스 내에 공지합니다.
              </p>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
}